import React, {useEffect, useState} from "react";
import axios from "axios";
import {URL_PAGAMENTO} from "../../config/urls";

export function DistribuicaoComprasComissao(props) {

  const [distribuido, setDistribuido] = useState(null);
  const [progess, setProgress] = useState(false);

  useEffect(() => {
    buscarStatus();
  }, []);

  const buscarStatus = async () => {
    setProgress(true);
    await axios.get(`${URL_PAGAMENTO}/administracao/comissao/distrbuicao/status/${props.contratoID}`, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("tokenPagamento")
      }
    })
      .then(async (response) => {
        setDistribuido(response.data.distribuicaoConcluida)
      }).catch(() => {
        alert("Não foi possível consultar o status de distribuição da planilha de compras da comissão!");
      })
      .finally(() => {
        setProgress(false);
      })
  }

  const mudarStatus = async () => {
    const status = distribuido;
    setDistribuido(!status);
    await axios.post(`${URL_PAGAMENTO}/administracao/comissao/concluir-distrbuicao`, {
      contratoID: props.contratoID,
      concluir: !status
    }, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("tokenPagamento")
      }
    })
      .then(async (response) => {
      })
      .catch(async () => {
        setDistribuido(status);
        alert("Não foi possível consultar o status de distribuição da planilha de compras da comissão!");
      })
      .finally(() => {
        setProgress(false);
      })
  }

  return (
    <div>
      {
        progess ?
          <i className="fa fa-spinner fa-pulse" />
          :
          <div>
            {
              distribuido != null?
                <div className="switch" style={{marginRight: '10px'}}>
                  <input type="checkbox"
                         className="switch__input"
                         id="swithPlanilhaCompras"
                         defaultChecked={distribuido}
                         onClick={() => {mudarStatus()}}/>
                  <label
                    className="switch__label"
                    htmlFor="swithPlanilhaCompras"
                    style={{ fontWeight: 400 }}>
                    Confirmar distribuição de compras da comissão
                  </label>
                </div>
                :
                null
            }
          </div>
      }
    </div>
  )

}


// WEBPACK FOOTER //
// ./src/components/contrato/DistribuicaoComprasComissao.jsx